import React from 'react'
import styled from 'styled-components'
import { colors } from '../styleGuide'

/* eslint-disable-next-line */
export interface PixelListProps {}

const ListContainer = styled.div`
  color: ${colors.primary} !important;
  border: 1px solid ${colors.grayBorderLight};
  height: auto;
  width: auto;
  min-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 5px;
`

export function PixelList(props: PixelListProps) {
  return (
    <ListContainer>
      <h1>Welcome to PixelList</h1>
    </ListContainer>
  )
}

export default PixelList

